import { MaterialCommunityIcons } from '@expo/vector-icons';

import type { Icon } from './internal';

export const Expand: Icon = ({ color = '#000000', size = 24 }) => (
  <MaterialCommunityIcons name="arrow-expand" size={size} color={color} />
);
